import { FormDialog } from "components/dialog/form"
import { KojinMatchingFormData } from "interface/kojin/match"
import { KojinSelfMatchingForm, useKojinSelfMatchingForm } from "../form/kojinSelfMatching"
import { Button } from "@mui/material"
import { useCallback } from "react"

type KojinSelfMatchingDialogProps = {
  formData: KojinMatchingFormData
  defaultFormData?: KojinMatchingFormData
  onSubmit: (data: KojinMatchingFormData) => void
  onClose: () => void
}
export const KojinSelfMatchingDialog = ({
  formData,
  defaultFormData,
  onSubmit,
  onClose
}: KojinSelfMatchingDialogProps) => {
  const form = useKojinSelfMatchingForm({ formData, onSubmit })
  const onClickedDefault = useCallback(
    () => {
      if (!defaultFormData) return
      form.setValue("name", defaultFormData.name)
      form.setValue("affiliation", defaultFormData.affiliation ?? '')
    },
    [defaultFormData, form]
  )
  return (
    <FormDialog
      open
      fullWidth
      maxWidth="md"
      title="名寄せの再実行"
      body={<KojinSelfMatchingForm {...form}/>}
      submitLabel="実行"
      isValid={form.formState.isValid}
      leftAction={
        <Button
          variant="outlined"
          disabled={defaultFormData ? false : true}
          size="large"
          onClick={onClickedDefault}
        >
          元に戻す
        </Button>
      }
      onSubmit={form.submit}
      onClose={onClose}
    />
  )
}